var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 28.0742C22.1289 28.0742 28.4453 21.7441 28.4453 14.1289C28.4453 6.5 22.1152 0.183594 14.4863 0.183594C6.87109 0.183594 0.554688 6.5 0.554688 14.1289C0.554688 21.7441 6.88477 28.0742 14.5 28.0742ZM14.5 25.75C8.04688 25.75 2.89258 20.582 2.89258 14.1289C2.89258 7.67578 8.0332 2.50781 14.4863 2.50781C20.9395 2.50781 26.1074 7.67578 26.1211 14.1289C26.1348 20.582 20.9531 25.75 14.5 25.75ZM12.9961 20.623C13.4473 20.623 13.8301 20.4043 14.1035 19.9805L20.3516 10.1504C20.502 9.89062 20.6797 9.57617 20.6797 9.27539C20.6797 8.67383 20.1328 8.27734 19.5586 8.27734C19.2168 8.27734 18.875 8.48242 18.6152 8.89258L12.9414 17.9844L10.248 14.5117C9.91992 14.0742 9.61914 13.9512 9.23633 13.9512C8.64844 13.9512 8.18359 14.4297 8.18359 15.0449C8.18359 15.332 8.30664 15.6328 8.49805 15.8926L11.834 19.9805C12.1758 20.4316 12.5449 20.623 12.9961 20.623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f9023bfae0ccceb9741da0bf73501f85.svg";
export { ForwardRef as ReactComponent };